import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getFilterState } from "../../functions/filterState/filterState";
import { filterOverview } from "../../utils/todo-utils";
import Task from "../task/Task";
import { Droppable } from "react-beautiful-dnd";
import { findByIdInTreeList } from "../../utils/tree";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";
import { deleteTaskFromFirebase } from "../../redux/actions/TodoManipulation/deleteTaskFromFirebaseAction";
import DeleteModal from '../editModal/DeleteModal';
import DatePickerModalComponent from "../datePickerModal/datePickerModal";
import { editTaskInFirebase } from "../../redux/actions/TodoManipulation/editTaskInFirebaseAction";

const UnsortedTasksPanel = ({ zoomLevel, isDragDisabled }) => {
    const isUnSortedOpen = useSelector(state => state.showUnsortedPanel);
    const selectedDate = useSelector((state) => state.selectedDate.date);
    const isMobile = useIsMobile();
    const feature = "Overview";
    const filterStateName = getFilterState(feature) ?? "Overview";
    const projects = useSelector((state) => state.taskList.data);
    const filterState = useSelector(state => state[filterStateName]);
    const filteredProjects = filterOverview(projects, filterState, new Date());
    const filteredTasks = filteredProjects.tasks;
    const [todoTitle, setTodoTitle] = useState('');
    const [todoChildren, setTodoChildren] = useState('');
    const [hiddenDate, setHiddenDate] = useState('');
    const [notificationDate, setNotificationDate] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [modalOpenDate, setModalOpenDate] = useState('');
    const [showDateModal, setShowDateModal] = useState(false);
    const [dateType, setDateType] = useState('');
    console.log(filteredTasks);
    const dispatch = useDispatch();
    const [todoId, setTodoId] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const toggleShowModal = (projectId, event) => {
        const allowedClassNames = [
            "gw-icon-button",
            "gt-task__completed",
            "gw-icon-button__icon"
        ];

        if (!allowedClassNames.some(className => event.target.classList.contains(className))) {
            const todoItem = findByIdInTreeList(projects, projectId);
            dispatch({ type: "TOGGLE_EDIT_MODAL", payload: { todo: todoItem } });
        }
    };
    const openDateModal = (dateType, title, todo) => {
        setDateType(dateType);
        setTodoId(todo.id);
        setTodoTitle(todo.title);
        setTodoChildren(todo.children ? todo.children.length : 0);

        switch (dateType) {
            case "hidden":
                todo.snoozedUntil ? setModalOpenDate(todo.snoozedUntil) : setModalOpenDate(null);
                break;
            case "notification":
                todo.notificationDate ? setModalOpenDate(todo.notificationDate) : setModalOpenDate(null);
                break;
            case "dueDate":
                todo.dueDate ? setModalOpenDate(todo.dueDate) : setModalOpenDate(null);
                break;
        }

        setShowDateModal(true);
    };

    const toggleShowDeleteModal = (todo) => {
        setTodoId(todo.id);
        setTodoTitle(todo.title);
        setTodoChildren(todo.children ? todo.children.length : 0);
        setShowDeleteModal(true);
    }

    const deleteTask = async () => {
        setShowDeleteModal(false);
        const json = { id: todoId };
        await dispatch(deleteTaskFromFirebase(json));
        closeDeleteModal();
    }

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const toggleShowDateModal = (dateType, title, todoId) => {
        openDateModal(dateType, title, todoId);
    };

    


    const closeDateModal = () => {
        setShowDateModal(false);
    };

    const clearDateModal = () => {
        setShowDateModal(false);

        switch (dateType) {
            case "hidden":
                setHiddenDate('');
                const json = {
                    id: todoId,
                    HasSnoozedUntil: "true",
                    SnoozedUntil: ''
                }
                dispatch(editTaskInFirebase(json));
                break;
            case "notification":
                setNotificationDate('');
                break;
            case "dueDate":
                setDueDate('');
                break;
        }
        setModalOpenDate('');
    };

    const saveDate = () => {
        setShowDateModal(false);

        switch (dateType) {
            case "hidden":
                setHiddenDate(selectedDate);

                const json = {
                    id: todoId,
                    HasSnoozedUntil: "true",
                    SnoozedUntil: selectedDate
                }

                dispatch(editTaskInFirebase(json));

                break;
            case "notification":
                setNotificationDate(selectedDate);
                break;
            case "dueDate":
                setDueDate(selectedDate);
                break;
        }
    };

    return (
        <div className={`gt-unsorted-panel ${isUnSortedOpen ? 'gt-unsorted-panel--active' : ''}`}
            style={{ fontSize: isMobile ? '10px' : `${zoomLevel}px` } }
        >
            <button aria-label="Hide unsorted panel"
                className="gw-icon-button gw-icon-button--icon gt-desktop-only"
                onClick={() => {
                    dispatch({ type: 'TOGGLE_UNSORTED_PANEL' });
                }}
            >
                <i className="gw-icon-button__icon gw-button__icon--close"></i>
            </button>
            <button className="gt-unsorted-panel__toggle gt-mobile-only" aria-label="Close menu"
                onClick={() => {
                    dispatch({ type: 'TOGGLE_UNSORTED_PANEL' });
                }}
            >
                <h3>Unsorted</h3>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-sidebar-toggle"></use>
                </svg>
            </button>

            <h3 className="gt-unsorted-panel__title">Unsorted Tasks</h3>
            <p className="gt-unsorted-panel__description">Drag tasks to place in a section</p>
            <Droppable droppableId="unsorted" type="task" isDropDisabled>
                {(provided) => (
                    <div style = {{ overflow: 'auto' } }
                        className="gt-unsorted-panel__tasks"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {filteredTasks.map((task, index) => (
                            <Task
                                key={task.$id}
                                task={task}
                                taskIndex={index}
                                zoomLevel={zoomLevel}
                                isProjectDragging={isDragDisabled}
                                toggleShowModal={toggleShowModal}
                                toggleShowDeleteModal={toggleShowDeleteModal}
                                toggleShowDateModal={toggleShowDateModal}
                            />
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
            <DeleteModal
                modalOpen={showDeleteModal}
                onClose={closeDeleteModal}
                onDelete={deleteTask}
                todoTitle={todoTitle}
                children={todoChildren}
            ></DeleteModal>
            <DatePickerModalComponent
                modalOpen={showDateModal}
                onClose={closeDateModal}
                onClear={clearDateModal}
                onSave={saveDate}
                type={dateType}
                todoTitle={todoTitle}
                date={modalOpenDate}
            ></DatePickerModalComponent>
        </div>
    );
};

export default UnsortedTasksPanel;
